var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSupplier(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 24,
    viewBox: "0 0 28 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.4479 22.6566C20.1132 22.6566 19.0312 21.5746 19.0312 20.2399C19.0312 18.9052 20.1132 17.8232 21.4479 17.8232C22.7826 17.8232 23.8646 18.9052 23.8646 20.2399C23.8646 21.5746 22.7826 22.6566 21.4479 22.6566Z",
    stroke: "#0067FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.15625 22.6566C6.82156 22.6566 5.73958 21.5746 5.73958 20.2399C5.73958 18.9052 6.82156 17.8232 8.15625 17.8232C9.49094 17.8232 10.5729 18.9052 10.5729 20.2399C10.5729 21.5746 9.49094 22.6566 8.15625 22.6566Z",
    stroke: "#0067FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M19.0312 19.0312H10.5729",
    stroke: "#0067FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M18.7292 19.0312C18.7292 19.5317 18.3234 19.9375 17.8229 19.9375C17.3224 19.9375 16.9167 19.5317 16.9167 19.0312H18.7292ZM3.02083 3.32292C3.02083 3.82342 2.61509 4.22917 2.11458 4.22917C1.61408 4.22917 1.20833 3.82342 1.20833 3.32292H3.02083ZM16.9167 19.0312V5.73958H18.7292V19.0312H16.9167ZM12.9896 1.8125H3.32292V0H12.9896V1.8125ZM3.02083 2.11458V3.32292H1.20833V2.11458H3.02083ZM3.32292 1.8125C3.15608 1.8125 3.02083 1.94775 3.02083 2.11458H1.20833C1.20833 0.946729 2.15506 0 3.32292 0V1.8125ZM16.9167 5.73958C16.9167 3.57071 15.1584 1.8125 12.9896 1.8125V0C16.1595 0 18.7292 2.5697 18.7292 5.73958H16.9167Z",
    fill: "#0067FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5729 7.25C11.0734 7.25 11.4792 7.65575 11.4792 8.15625C11.4792 8.65675 11.0734 9.0625 10.5729 9.0625V7.25ZM0.90625 9.0625C0.405743 9.0625 0 8.65675 0 8.15625C0 7.65575 0.405743 7.25 0.90625 7.25V9.0625ZM10.5729 9.0625H0.90625V7.25H10.5729V9.0625Z",
    fill: "#0067FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.5729 10.875C11.0734 10.875 11.4792 11.2808 11.4792 11.7812C11.4792 12.2817 11.0734 12.6875 10.5729 12.6875V10.875ZM4.53125 12.6875C4.03075 12.6875 3.625 12.2817 3.625 11.7812C3.625 11.2808 4.03075 10.875 4.53125 10.875V12.6875ZM10.5729 12.6875H4.53125V10.875H10.5729V12.6875Z",
    fill: "#0067FF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.8646 10.875C24.3651 10.875 24.7708 11.2808 24.7708 11.7812C24.7708 12.2817 24.3651 12.6875 23.8646 12.6875V10.875ZM17.8229 12.6875C17.3224 12.6875 16.9167 12.2817 16.9167 11.7812C16.9167 11.2808 17.3224 10.875 17.8229 10.875V12.6875ZM23.8646 12.6875H17.8229V10.875H23.8646V12.6875Z",
    fill: "#0067FF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M2.11458 16.6143V17.8226C2.11458 18.49 2.65558 19.0309 3.32292 19.0309H5.73958",
    stroke: "#0067FF",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M17.8229 6.94824H21.099C21.4581 6.94813 21.8101 7.05219 22.1156 7.24879C22.4211 7.44537 22.668 7.72671 22.8287 8.06125L23.8646 11.7816L26.2502 12.5768C26.9904 12.8235 27.4896 13.5161 27.4896 14.2962V17.2191C27.4896 18.2201 26.6781 19.0316 25.6771 19.0316H23.8646",
    stroke: "#0067FF",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupplier);
export default __webpack_public_path__ + "static/media/supplier.dc46fafff34a4c63f96095335e613ead.svg";
export { ForwardRef as ReactComponent };